import { render, staticRenderFns } from "./SelectedFilters.vue?vue&type=template&id=4ba3102a&scoped=true&"
import script from "./SelectedFilters.vue?vue&type=script&lang=ts&"
export * from "./SelectedFilters.vue?vue&type=script&lang=ts&"
import style0 from "./SelectedFilters.vue?vue&type=style&index=0&id=4ba3102a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba3102a",
  null
  
)

export default component.exports